import CriteriaModal from './CriteriaModal'

export default CriteriaModal;
